// DS: C39
/** A navigation bar with actions related to the deviation on top of it. */
import React from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { getDeviationResourceType } from '../DeviationViews/_helpers';
import ActionBarContent from './_partials/ActionBarContent';
import CustomNotificationProvider from '../Notifications/CustomNotificationContext';
import { getDeviationNotificationQueue } from '../DeviationPage/redux/helpers';
import { ActionBarProps } from './types';
import { ActionBarDialogContext } from './ActionBarContext';
import { StandardDeviationElementPlacementContextProvider } from './ElementPlacementContext/variants/standard/context';
import { StashElementPlacementContextProvider } from './ElementPlacementContext/variants/stash/context';

export interface Props extends ActionBarProps {
  isAnyDialogOpen?: boolean;
}

const ActionBar: React.FC<React.PropsWithChildren<Props>> = props => {
  const ElementPlacementContextProvider = props.deviation.isPublished
    ? StandardDeviationElementPlacementContextProvider
    : StashElementPlacementContextProvider;
  return (
    <BiLoggerContextProvider
      value={{
        itemid: props.deviation.deviationId,
        typeid: getDeviationResourceType(props.deviation),
      }}
    >
      <ActionBarDialogContext.Provider value={!!props.isAnyDialogOpen}>
        <ElementPlacementContextProvider deviation={props.deviation}>
          <CustomNotificationProvider
            queueName={getDeviationNotificationQueue(props.deviation)}
          >
            <ActionBarContent {...props} />
          </CustomNotificationProvider>
        </ElementPlacementContextProvider>
      </ActionBarDialogContext.Provider>
    </BiLoggerContextProvider>
  );
};
ActionBar.displayName = 'ActionBar';

export default ActionBar;
